const Loading = () => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <svg
        className="animate-spin -ml-1 mr-3 h-8 w-8 text-green-500 text-xl"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647zm10-2.647a7.962 7.962 0 013-2.645l-3-2.647A7.962 7.962 0 0116 12h-4zm-6-7.938A7.962 7.962 0 0112 4v4c-1.654 0-3.164.51-4.43 1.373l2.647 3z"
        ></path>
      </svg>
      <p className="text-white text-xl">Loading...</p>
    </div>
  );
};

export default Loading;
